<template>
  <div
    :class="
      paymentOption === 'CC'
        ? 'option-active rounded-lg'
        : 'option-deactive rounded-lg'
    "
    @click="selectPayment('CC')"
  >
    <v-row class="py-4 px-6" no-gutters align="center">
      <v-icon>mdi-credit-card-outline</v-icon>
      <v-col cols="8" class="pl-8">
        <v-row no-gutters>
          <span class="accent--text">{{ $t("payment.card.creditCard") }}</span>
        </v-row>
        <v-row
          v-if="
            selectedLanguage === 'pt' && buyer?.typeDocument !== 'foreigner'
          "
          no-gutters
        >
          <span class="checkout-h4 grey--text"
            >{{ $t("payment.card.payBy")
            }}{{ interests.parcelas.length }}x</span
          >
        </v-row>
      </v-col>
      <v-spacer></v-spacer>
      <v-radio-group class="pa-0 ma-0" hide-details :value="paymentOption">
        <v-radio color="primary" id="CC" value="CC"></v-radio>
      </v-radio-group>
    </v-row>
    <div
      v-if="paymentOption === 'CC'"
      :class="buyer?.typeDocument === 'foreigner' ? 'pt-4 px-4' : 'px-4'"
    >
      <div v-if="!buyer?.countryPhone || buyer?.countryPhone === 'BR'">
        <v-row v-if="buyer?.typeDocument !== 'foreigner'" no-gutters>
          <span class="checkout-h3 accent--text" style="font-weight: 400">{{
            $t("payment.card.installment")
          }}</span>
        </v-row>

        <v-radio-group
          v-if="buyer?.typeDocument !== 'foreigner'"
          v-model="card.installment_amount"
          @change="changeInput"
        >
          <v-row v-if="$vuetify.breakpoint.mdAndUp" no-gutters>
            <v-col>
              <v-row
                v-for="installment in interests.parcelas.slice(0, 3)"
                :key="installment.value.instalments"
                no-gutters
                class="pb-4"
              >
                <v-radio :value="installment.value">
                  <template v-slot:label>
                    <span
                      class="accent--text"
                      style="font-size: 14px; font-weight: 450"
                      >{{ installment.text }}</span
                    >
                  </template>
                </v-radio>
              </v-row>
            </v-col>
            <v-col>
              <v-row
                v-for="installment in interests.parcelas.slice(3, 6)"
                :key="installment.value.instalments"
                no-gutters
                class="pb-4"
              >
                <v-radio :value="installment.value">
                  <template v-slot:label>
                    <span
                      class="accent--text"
                      style="font-size: 14px; font-weight: 450"
                      >{{ installment.text }}</span
                    >
                  </template>
                </v-radio>
              </v-row>
            </v-col>
            <v-col>
              <v-row
                v-for="installment in interests.parcelas.slice(6, 9)"
                :key="installment.value.instalments"
                no-gutters
                class="pb-4"
              >
                <v-radio :value="installment.value">
                  <template v-slot:label>
                    <span
                      class="accent--text"
                      style="font-size: 14px; font-weight: 450"
                      >{{ installment.text }}</span
                    >
                  </template>
                </v-radio>
              </v-row>
            </v-col>

            <v-col v-if="interests?.parcelas?.length > 9">
              <v-row
                v-for="installment in interests.parcelas.slice(9, 12)"
                :key="installment.value.instalments"
                no-gutters
                class="pb-4"
              >
                <v-radio :value="installment.value">
                  <template v-slot:label>
                    <span
                      class="accent--text"
                      style="font-size: 14px; font-weight: 450"
                      >{{ installment.text }}</span
                    >
                  </template>
                </v-radio>
              </v-row>
            </v-col>
          </v-row>

          <!-- MOBILE -->

          <v-row v-else no-gutters>
            <v-col>
              <v-row
                v-for="installment in interests.parcelas.slice(
                  0,
                  columnDivider
                )"
                :key="installment.value.instalments"
                no-gutters
                class="pb-4"
              >
                <v-radio :value="installment.value">
                  <template v-slot:label>
                    <span
                      class="accent--text"
                      style="font-size: 14px; font-weight: 450"
                      >{{ installment.text }}</span
                    >
                  </template>
                </v-radio>
              </v-row>
            </v-col>
            <v-col>
              <v-row
                v-for="installment in interests.parcelas.slice(
                  columnDivider,
                  interests.parcelas.length
                )"
                :key="installment.value.instalments"
                no-gutters
                class="pb-4"
              >
                <v-radio :value="installment.value">
                  <template v-slot:label>
                    <span
                      class="accent--text"
                      style="font-size: 14px; font-weight: 450"
                      >{{ installment.text }}</span
                    >
                  </template>
                </v-radio>
              </v-row>
            </v-col>
          </v-row>
        </v-radio-group>

        <v-row
          v-if="
            paymentOptionsDetails?.credit_card_interest &&
            interests?.parcelas?.length > 1 &&
            paymentOptionsDetails?.credit_card_installments_with_no_interest <
              interests?.parcelas.length &&
            buyer?.typeDocument !== 'foreigner'
          "
          class="mb-6 mt-n4"
          no-gutters
        >
          <span style="color: #5e6b7e; font-size: 14px; font-weight: 400">
            * {{ $t("payment.card.includesInterestFrom") }}
            {{ creditCardInterest }}% {{ $t("payment.card.perMonth") }}
          </span>
        </v-row>
      </div>
      <v-row no-gutters>
        <v-col
          :class="$vuetify.breakpoint.mdAndUp ? 'pr-2' : ''"
          :cols="$vuetify.breakpoint.mdAndUp ? '4' : '12'"
        >
          <v-row class="mt-n2" no-gutters>
            <span class="checkout-h3 accent--text" style="font-weight: 400">{{
              $t("payment.card.number")
            }}</span>
          </v-row>
          <v-text-field
            outlined
            required
            autocomplete="cc-number"
            :rules="cardNumberRule"
            :validate-on-blur="card?.card_number?.length < 19"
            v-model="card.card_number"
            type="tel"
            v-mask="'#### #### #### ####'"
            @input="changeInput"
          ></v-text-field>
        </v-col>
        <v-col :cols="$vuetify.breakpoint.mdAndUp ? '4' : '6'" class="pr-2">
          <v-row class="mt-n2" no-gutters>
            <span class="checkout-h3 accent--text" style="font-weight: 400">{{
              $t("payment.card.validDate")
            }}</span>
          </v-row>
          <v-text-field
            outlined
            required
            :rules="cardValidateRules"
            type="tel"
            placeholder="mm/aa"
            autocomplete="cc-exp"
            v-model="card.card_expiration"
            v-mask="'##/##'"
            @input="changeInput"
          ></v-text-field>
        </v-col>
        <v-col :cols="$vuetify.breakpoint.mdAndUp ? '4' : '6'">
          <v-row class="mt-n2" no-gutters>
            <span class="checkout-h3 accent--text" style="font-weight: 400">{{
              $vuetify.breakpoint.mdAndUp
                ? $t("payment.card.securityCode")
                : $t("payment.card.securityCodeAbbrev")
            }}</span>
          </v-row>
          <v-text-field
            outlined
            required
            type="tel"
            autocomplete="cc-csc"
            v-model="card.card_cvv"
            :rules="cvcRules"
            v-mask="'####'"
            slot="activator"
            @input="changeInput"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row class="mt-n2" no-gutters>
        <span class="checkout-h3 accent--text" style="font-weight: 400">{{
          $t("payment.card.namePrinted")
        }}</span>
      </v-row>
      <v-text-field
        outlined
        required
        autocomplete="cc-name"
        :rules="cardNameRule"
        v-model="card.card_name"
        @input="changeInput"
      ></v-text-field>
      <v-row
        v-if="erroMessageCard"
        justify="center"
        class="mb-4 mt-n2"
        no-gutters
      >
        <span class="red--text">{{ erroMessageCard }}</span>
      </v-row>
      <v-row class="mb-4 mt-n2" no-gutters>
        <v-btn
          v-if="!loading"
          width="100%"
          rounded
          depressed
          height="40"
          color="primary"
          :disabled="!canPurchase || !paymentOption"
          @click="$emit('purchase')"
          >{{ $t("summary.confirm") }}</v-btn
        >
      </v-row>
      <v-row class="pb-4" align="center" justify="center" no-gutters>
        <v-col v-if="!$vuetify.breakpoint.mdAndUp" align="center">
          <v-icon class="mr-2" color="grey">mdi-lock</v-icon>
        </v-col>
        <v-col v-if="!$vuetify.breakpoint.mdAndUp" cols="10">
          <span class="checkout-h5 accent--text">{{
            $t("payment.notStored")
          }}</span>
        </v-col>
        <v-icon v-if="$vuetify.breakpoint.mdAndUp" class="mr-2" color="grey"
          >mdi-lock</v-icon
        >
        <span
          v-if="$vuetify.breakpoint.mdAndUp"
          class="checkout-h5 accent--text"
          >{{ $t("payment.notStored") }}</span
        >
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { mask, masked } from "vue-the-mask";
import Vue from "vue";
export default {
  directives: { mask, masked },
  props: ["couponCard", "loading"],
  data() {
    return {
      card: {
        installment_amount: null,
        card_name: "",
        card_number: "",
      },
      rules: [(v) => !!v || this.$t("errors.required")],
      cardNameRule: [
        (v) => !!v || this.$t("errors.required"),
        (v) => /^[a-zA-Z\u00C0-\u024F\s]+$/.test(v) || "Somente letras",
      ],
      cardValidateRules: [
        (v) => !!v || this.$t("errors.required"),
        (v) => {
          if (
            v?.length >= 2 &&
            (Number(v.slice(0, 2)) < 1 || Number(v.slice(0, 2)) > 12)
          )
            return "Validade inválida";
          if (v?.length == 5) {
            let currentYear = Number(this.$moment().format("YY"));
            if (
              Number(v.slice(3)) < currentYear ||
              Number(v.slice(3)) > currentYear + 10
            )
              return "Validade inválida";
            if (this.$moment().format("MM/YY") == v) return true;
            else if (
              this.$moment().isAfter(
                this.$moment(v, "MM/YY").format("YYYY-MM-DD HH:mm:ss")
              )
            )
              return "Validade inválida";
            else return true;
          } else return true;
        },
      ],
      cvcRules: [
        (v) => !!v || this.$t("errors.required"),
        (v) => /(\d{3,4})/.test(v) || "Código" + this.$t("errors.invalid"),
      ],
      cardNumberRule: [
        (v) => !!v || this.$t("errors.required"),
        (v) => {
          let replaced = "";
          if (v) replaced = v.replace(/\s/g, "");
          const visa = /^4[0-9]{12}(?:[0-9]{3})?$/;
          const master =
            /^(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$/;
          const amex = /^3[47][0-9]{13}$/;
          const dinners = /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/;
          const discover = /^6(?:011|5[0-9]{2})[0-9]{12}$/;
          const jcb = /^(?:2131|1800|35\d{3})\d{11}$/;
          const elo =
            /^((((636368)|(438935)|(504175)|(451416)|(636297))\d{0,10})|((5067)|(4576)|(4011))\d{0,12})$/;
          const hipercard = /^(606282\d{10}(\d{3})?)|(3841\d{15})$/;
          const maestro = /^(?:5[0678]\d\d|6304|6390|67\d\d)\d{8,15}$/;

          if (replaced?.length) {
            var checksum = 0;
            var calc;
            var j = 1;
            for (let i = replaced.length - 1; i >= 0; i--) {
              // Extract the next digit and multiply by 1 or 2 on alternative digits.
              calc = Number(replaced.charAt(i)) * j;

              // If the result is in two digits add 1 to the checksum total
              if (calc > 9) {
                checksum = checksum + 1;
                calc = calc - 10;
              }

              // Add the units element to the checksum total
              checksum = checksum + calc;

              // Switch the value of j
              if (j == 1) {
                j = 2;
              } else {
                j = 1;
              }
            }

            // All done - if checksum is divisible by 10, it is a valid modulus 10.
            // If not, report an error.
            if (checksum % 10 != 0) {
              return "Cartão" + this.$t("errors.invalid");
            }
          }

          if (visa.test(replaced)) {
            return true;
          }
          if (master.test(replaced)) {
            return true;
          }
          if (amex.test(replaced)) {
            return true;
          }
          if (dinners.test(replaced)) {
            return true;
          }
          if (discover.test(replaced)) {
            return true;
          }
          if (jcb.test(replaced)) {
            return true;
          }
          if (elo.test(replaced)) {
            return true;
          }
          if (hipercard.test(replaced)) {
            return true;
          }
          if (maestro.test(replaced)) {
            return true;
          }
          return "Cartão" + this.$t("errors.invalid");
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "paymentOption",
      "interests",
      "buyer",
      "canPurchase",
      "erroMessageCard",
      "paymentOptionsDetails",
      "selectedLanguage",
    ]),
    creditCardInterest() {
      return Vue.options.filters
        .currency(this.paymentOptionsDetails.credit_card_interest)
        .replace("R$ ", "");
    },
    columnDivider() {
      if (this.interests?.parcelas?.length > 4)
        return Math.ceil(this.interests?.parcelas?.length / 2);
      else if (this.interests?.parcelas?.length <= 4) return 3;
      return 0;
    },
  },
  watch: {
    paymentOption(v) {
      if (v && v === "CC") {
        this.card.installment_amount = this.interests.parcelas[0].value;
        this.$store.commit("SET_BUYER_DATA", { ...this.buyer, ...this.card });
        this.card.card_number = this.couponCard;
      }
    },
    "buyer.countryPhone"(v) {
      if (v && v !== "BR")
        this.card.installment_amount = this.interests.parcelas[0].value;
    },
    "buyer.typeDocument"() {
      console.log("aquii", this.buyer.typeDocument);
      if (this.buyer.typeDocument === "foreigner") {
        this.card.installment_amount = this.interests.parcelas[0].value;
        this.$store.commit("SET_BUYER_DATA", { ...this.buyer, ...this.card });
      }
    },
    "card.card_number"() {
      if (this.couponCard && this.card.card_number.length < 7) {
        let coupon = `${this.couponCard.slice(0, 4)}-${this.couponCard.slice(
          4,
          6
        )}`;

        this.card.card_number = coupon;
      }
    },
    card(v) {
      this.$store.commit("SET_ERROR_MESSAGE_CARD", "");
      if (v) this.$store.commit("SET_BUYER_DATA", { ...this.buyer, ...v });
    },
  },
  methods: {
    changeInput() {
      this.$store.commit("SET_ERROR_MESSAGE_CARD", "");
      this.$store.commit("SET_BUYER_DATA", { ...this.buyer, ...this.card });
    },
    selectPayment(credit) {
      this.$store.dispatch("setPaymentOption", credit);
    },
  },
};
</script>
